<aside
  class="sidebar-shell flex flex-col h-full w-full overflow-hidden"
  [class.chrome-dark]="themeService.isDark()"
  [class.chrome-light]="themeService.isLight()">

  <div class="sidebar-glow" aria-hidden="true"></div>
  <div class="sidebar-grid" aria-hidden="true"></div>

  <!-- Header -->
  <header class="sidebar-header shrink-0 relative z-10 px-4 flex items-center justify-between">
    <a class="logo-link group flex items-center gap-3 min-w-0" [routerLink]="['/']">
      <span class="logo-icon">
        <img src="assets/images/pento-icon.png" alt="Pento" class="w-6 h-6 rounded-md relative z-10">
      </span>
      <div class="min-w-0">
        <h2 class="brand-title text-xl font-bold tracking-tight leading-tight">Pento</h2>
        <p class="brand-subtitle text-xs font-semibold uppercase tracking-[0.2em] leading-none mt-0.5">Payments</p>
      </div>
    </a>
    <div class="flex items-center gap-1">
      <button
        type="button"
        class="theme-toggle-btn"
        (click)="themeService.toggleTheme()"
        [attr.aria-label]="themeService.isDark() ? 'Cambiar a tema claro' : 'Cambiar a tema oscuro'"
        [matTooltip]="themeService.isDark() ? 'Tema claro' : 'Tema oscuro'">
        <mat-icon>{{ themeService.isDark() ? 'light_mode' : 'dark_mode' }}</mat-icon>
      </button>
      <button
        type="button"
        (click)="toggleSidebar.emit()"
        class="sidebar-close-btn lg:hidden"
        aria-label="Cerrar menú">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </header>

  <!-- Navigation -->
  @if (activeCategory()) {
  <nav class="sidebar-nav relative z-10 flex-1 overflow-y-auto overflow-x-hidden px-3 py-2 pb-2 animate-fade-in">
    <div class="sidebar-nav-panel">
    @for (group of navGroups(); track group.id; let i = $index) {
    <section
      class="nav-section-card"
      [class]="sectionAccent(group.name)"
      [style.animation-delay]="i * 40 + 'ms'">

      <button
        type="button"
        (click)="expandMenuItem(group.id!)"
        class="nav-group-trigger"
        [class.nav-group-trigger--active]="isGroupActive(group)"
        [class.nav-group-trigger--open]="group.isExpanded"
        [attr.aria-expanded]="group.isExpanded">
        <span class="nav-group-trigger__accent"></span>
        <span class="nav-icon-wrap nav-icon-wrap--section">
          <mat-icon>{{ group.icon }}</mat-icon>
        </span>
        <span class="flex-1 text-left truncate">{{ group.name }}</span>
        <mat-icon class="nav-chevron" [class.nav-chevron--open]="group.isExpanded">expand_more</mat-icon>
      </button>

      @if (group.isExpanded) {
      <ul class="nav-sublist">
        @for (item of group.items; track item.id) {
        <li class="nav-subitem" [class.nav-subitem--separator]="item.type === 'separator'">
          @if (item.type === 'separator') {
          <span class="nav-sublist-separator" role="separator" aria-hidden="true"></span>
          } @else {
          <div
            class="nav-link-row group/sub"
            routerLinkActive="nav-link-row--active"
            [routerLinkActiveOptions]="{ exact: item.exact ?? true }">
            <a
              [routerLink]="item.route"
              class="nav-link">
              <span class="nav-icon-wrap nav-icon-wrap--sub">
                <mat-icon>{{ item.icon }}</mat-icon>
              </span>
              <span class="truncate">{{ item.name }}</span>
            </a>
            @if (item.newRoute) {
            <button
              type="button"
              (click)="$event.stopPropagation(); canCreate(item) && navigateTo(item.newRoute!)"
              class="nav-action-btn"
              [disabled]="!canCreate(item)"
              [class.opacity-40]="!canCreate(item)"
              [class.pointer-events-none]="!canCreate(item)"
              [matTooltip]="item.newRouteTooltip || 'Nuevo'"
              matTooltipClass="nav-plus-tooltip">
              <mat-icon>add</mat-icon>
            </button>
            }
          </div>
          }
        </li>
        }
      </ul>
      }
    </section>
    }
    </div>
  </nav>
  }

  <!-- Footer -->
  <footer class="sidebar-footer relative z-10 shrink-0">
    <p class="sidebar-copyright">© 2026 Pento.mx</p>
  </footer>

</aside>
